import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material"
import { orderBy } from "lodash"
import { useMemo } from "react"
import { formatMoney } from "../../../../utils"
import { useTheme } from "@mui/material"

interface RankingProps { 
    ranking: Array<{ user: string, price_per_k: number | string }>
    bid: {user: string, price_per_k: number | string }
}

export const Ranking = ({ ranking, bid }: RankingProps) => {
    const theme = useTheme()

    const currentUserStyle = {
        fontWeight: 'bold',
        color: theme.palette.primary.main
    }

    const allRows = useMemo(() => {
        const all = [
            ...ranking,
            bid
        ].map(item => {
            return {
                ...item, 
                price_per_k: Number(item.price_per_k)
            }
        })

        return orderBy(all, item => Number(item.price_per_k))
    }, [ranking, bid])
    
    return (
        <TableContainer>
            <Table>
                <TableHead>
                <TableRow>
                    <TableCell>
                    #
                    </TableCell>
                    <TableCell>
                    Usuário
                    </TableCell>
                    <TableCell>
                    Preço por 1.000 milhas
                    </TableCell>
                </TableRow>
                </TableHead>
                <TableBody>
                    {
                        allRows.map((item, index) => {
                            return (
                                <TableRow>
                                    <TableCell style={item.user === bid.user ? currentUserStyle : undefined}>{index + 1}º</TableCell>
                                    <TableCell style={item.user === bid.user ? currentUserStyle : undefined}>{item.user}</TableCell>
                                    <TableCell style={item.user === bid.user ? currentUserStyle : undefined}>{formatMoney(item.price_per_k)}</TableCell>
                                </TableRow>
                            )
                        })
                    }
                </TableBody>
            </Table>
        </TableContainer>
    )
}